import React, { useEffect } from 'react';
import Header from './components/layout/Header';
import Hero from './components/layout/Hero';
import ParkingInfo from './components/layout/ParkingInfo';
import Navigation from './components/layout/Navigation';
import SoughtFlights from './components/layout/SoughtFlights';
import ContactSection from './components/layout/ContactSection';
import Footer from './components/layout/Footer';
import FlightBoard from './components/FlightBoard';
import './App.css';

function App() {

  useEffect(() => {
    // Add CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://bookingjourney-widget-v3.netlify.app/bundle.css';
    document.head.appendChild(link);
    


    // Add JavaScript
    const script = document.createElement('script');
    script.src = 'https://bookingjourney-widget-v3.netlify.app/bundle.js';
    script.async = true;
    document.body.appendChild(script);
    // Add JavaScript

    // Cleanup function
    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);

    };
  }, []); // Empty dependency array means this runs once on mount


  
  return (
    <div className="lil-min-h-screen lil-bg-gray-50">
      <Header />
      <Hero />
      {/* <FlightBoard /> */}
      <div className="lil-container lil-mx-auto lil-px-4">
        {/* <ParkingInfo /> */}
        {/* <Navigation /> */}
        {/* <SoughtFlights /> */}
        {/* <ContactSection /> */}
      </div>
      <Footer />
    </div>
  );
}

export default App;
